import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { EditPageHeader } from "../../components/EditPageHeader";
import { useTranslation } from "../../locale/useTranslation";
import { TOAST_TYPES, ENTITYNAME, LOCALSTORAGE_KEY } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import ContractCollectionSelection from "./ContractCollectionSelection";

const ContractAdditionalCostForm = (props) => {
    const lang = useTranslation();
    const { onSaveData, cancelEdit } = props;
    let user = utility.getValue(LOCALSTORAGE_KEY.userData);

    const blankDataItem = {
        ...props.data,
        ContractTitle: props.data?.ContractTitle ?? {},
        Supplier: props.data?.Supplier ?? {},
        CostType: props.data?.CostType ?? "",
        Amount: props.data?.Amount ?? 0,
        Currency: props.data?.Currency ?? {},
        Tax: props.data?.Tax ?? 0,
        Inventoried: props.data?.Inventoried ?? false,
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [suppliers, setSuppliers] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [showCollectionSelection, setShowCollectionSelection] = useState(false);

    useEffect(() => {
        loadLookups();
    }, []);

    const loadLookups = async () => {
        let supplierRes = await API.getDataLookup(ENTITYNAME.Licensor, { sort: { Description: 1 } });
        setSuppliers(supplierRes.data);

        let currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
        setCurrencies(currencyRes.data);
    };

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setDataItem({ ...dataItem, [name]: type === "checkbox" ? checked : value });
    };

    const isValid = () => {
        if (!dataItem.ContractTitle || Object.keys(dataItem.ContractTitle).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_contract_error_message });
            return false;
        }
        if (!dataItem.Supplier || Object.keys(dataItem.Supplier).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_supplier_error_message });
            return false;
        }
        if (!dataItem.CostType) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_cost_type_error_message });
            return false;
        }
        if (!dataItem.Currency || Object.keys(dataItem.Currency).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_Currency_error_message });
            return false;
        }
        if (dataItem.Amount === "" || dataItem.Amount === null) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_amount_error_message });
            return false;
        }
        if (dataItem.Tax === "" || dataItem.Amount === null) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_tax_error_message });
            return false;
        }
        if (dataItem.Amount !== "" && dataItem.Amount !== null && Number(dataItem.Amount) <= 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.amount_cannot_be_zero_or_negative_error_message });
            return false;
        }
        if (dataItem.Tax !== "" && dataItem.Tax !== null && Number(dataItem.Tax) < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.tax_can_not_be_negative_error_message });
            return false;
        }
        return true;
    };

    const handleSubmit = () => {
        if (isValid()) {
            const additionalCost = {
                ...dataItem,
                ContractTitle: dataItem?.ContractTitle && Object.keys(dataItem?.ContractTitle).length > 0 ? {
                    _id: dataItem?.ContractTitle?._id,
                    Title: dataItem?.ContractTitle?.Title,
                } : {},
                Supplier: dataItem?.Supplier && Object.keys(dataItem?.Supplier).length > 0 ? {
                    _id: dataItem?.Supplier?._id,
                    Name: dataItem?.Supplier?.Name,
                } : {},
                CostType: dataItem.CostType,
                Amount: dataItem.Amount,
                Currency: dataItem?.Currency && Object.keys(dataItem?.Currency).length > 0 ? {
                    _id: dataItem?.Currency?._id,
                    Description: dataItem?.Currency?.Description,
                } : {},
                Tax: dataItem.Tax,
                Inventoried: dataItem.Inventoried,
                AddOn: new Date().getTime(),
                AddBy: {_id : user?._id, Name: user?.name}
            };
            onSaveData(additionalCost);
        }
    };

    const handleContractTitleSelect = (selectedData) => {
        const item = Array.isArray(selectedData) ? selectedData[0] : selectedData;
        setDataItem({
            ...dataItem,
            ContractTitle: item || {},
        });
        setShowCollectionSelection(false);
    };

    return (
        <>
            <BossDialog title={"Additional Cost"} onClose={cancelEdit} width="800px" height="auto">
                <div className="p-1">
                    <EditPageHeader showTitle={false} onSubmit={handleSubmit} onCancel={cancelEdit} />
                    <div className="row mt-2">
                        <div className="col-4 form-group">
                            <label htmlFor="ContractTitle">{lang.contract_title_label} *</label>
                            <div style={{ display: "flex" }}>
                                <input
                                    name="ContractTitle"
                                    type="text"
                                    className="d-inline form-control form-control-sm"
                                    value={dataItem?.ContractTitle?.Title || dataItem?.ContractTitle?.ContractNumber || ""}
                                    disabled={true}
                                />
                                <button
                                    type="button"
                                    title="Select Contract"
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                    style={{ height: "30px", marginLeft: "5px" }}
                                    onClick={() => setShowCollectionSelection(true)}
                                >
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                <button
                                    type="button"
                                    title="Clear Contract"
                                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                                    style={{ height: "30px", marginLeft: "5px" }}
                                    onClick={() => setDataItem({ ...dataItem, ContractTitle: {} })}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <div className="col-4 form-group">
                            <label htmlFor="Supplier">{lang.supplier_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={suppliers}
                                name="Supplier"
                                textField="Name"
                                dataItemKey="_id"
                                value={dataItem.Supplier}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-4 form-group">
                            <label htmlFor="CostType">{lang.cost_type_label} *</label>
                            <input
                                type="text"
                                name="CostType"
                                placeholder="Enter Cost Type"
                                className="form-control form-control-sm"
                                value={dataItem.CostType}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-1">
                        <div className="col-4 form-group">
                            <label htmlFor="Currency">{lang.currency_label} *</label>
                            <DropDownList
                                style={{ backgroundColor: "white" }}
                                data={currencies}
                                name="Currency"
                                textField="Description"
                                dataItemKey="_id"
                                value={dataItem.Currency}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-4 form-group">
                            <label htmlFor="Amount">{lang.amount_label} *</label>
                            <input
                                type="number"
                                name="Amount"
                                min="0"
                                placeholder="Enter Amount"
                                className="form-control form-control-sm"
                                value={dataItem.Amount}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-4 form-group">
                            <label htmlFor="Tax">{lang.tax_label} *</label>
                            <input
                                type="number"
                                name="Tax"
                                min="0"
                                placeholder="Enter Tax"
                                className="form-control form-control-sm"
                                value={dataItem.Tax}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row mt-1 align-items-center">
                        <div className="col-12 form-group">
                            <input
                                type="checkbox"
                                name="Inventoried"
                                checked={dataItem.Inventoried}
                                onChange={onChange}
                            />
                            <label className="ml-1" htmlFor="Inventoried">{lang.inventoried_label}</label>
                        </div>
                    </div>
                </div>
            </BossDialog>
            {showCollectionSelection && (
                <ContractCollectionSelection
                    addButtonTitle={lang.select_button_text}
                    title={lang.media_library_dialog_header}
                    wherestatement={['MediaCategory.isLong', '=', true]}
                    setDataList={handleContractTitleSelect}
                    entityname={ENTITYNAME.MediaEpisode}
                    closeForm={() => setShowCollectionSelection(false)}
                    width={"50vw"}
                    mode={"single"}
                />
            )}
        </>
    );
};

export default ContractAdditionalCostForm;
